export default "__VITE_ASSET__D950zn0S__"